/**
 * Ambient background animations (star twinkle, nebula and scenery float) are
 * off by default because their infinite CSS animations force a full-screen
 * recomposite every frame, which pins a CPU core without GPU acceleration.
 * GitHub issue #356 will back this with a player option. This hook is the
 * single switch both `SpaceBackdrop` and `PlanetSurface` read.
 *
 * `prefers-reduced-motion` is not checked here: the `index.css` media query
 * suppresses every looping animation class, whoever applies it.
 */
export function useAmbientAnimations(): boolean {
    return false;
}
